import React from 'react';
import { twMerge } from 'tailwind-merge';

export enum BADGE_STATUS {
  success = 'success',
  failed = 'failed',
  pending = 'pending',
}

interface BadgeProps {
  status: BADGE_STATUS;
  label: string;
}

const badgeColorMap = {
  [BADGE_STATUS.success]: 'bg-ph-green-dark bg-opacity-10 border-ph-green-dark',
  [BADGE_STATUS.pending]: 'bg-ph-orange bg-opacity-10 border-ph-orange',
  [BADGE_STATUS.failed]: 'bg-ph-red-darker bg-opacity-10 border-ph-red-darker',
};

const textColorMap = {
  [BADGE_STATUS.success]: 'text-ph-green-dark',
  [BADGE_STATUS.pending]: 'text-ph-orange',
  [BADGE_STATUS.failed]: 'text-ph-red-secondary',
};

const Badge: React.FC<BadgeProps> = ({ status, label }) => {
  const badgeColor = badgeColorMap[status];
  const textColor = textColorMap[status];
  return (
    <span
      className={twMerge(
        'inline-block rounded-full border-[1px] px-3 py-1 text-sm font-semibold',
        badgeColor,
        textColor,
      )}
    >
      {label}
    </span>
  );
};

export default Badge;
